define(['bootstrap/collapse'], function (Collapse) {
    'use strict';

    return (config, element) => new Collapse(element);
});
